areaMembros.component('areaMembros.areaMembrosComponent', {
    templateUrl: 'areaMembros/areaMembros.html',
    controller: 'areaMembros.areaMembrosController',
    controllerAs: '$ctrl'
});

areaMembros.controller('areaMembros.areaMembrosController', ['$scope', 'coreLanguage', '$state', 'coreFb', '$timeout', function($scope, $text, $state, $fb, $timeout) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {};

    const _tableRerender=()=>{
        let config = angular.copy($ctrl.tableObj);
        $ctrl.tableObj = null;
        $timeout(()=>{ $ctrl.tableObj = config; }, 100);
    };

    const _getAreas=()=>{
        $state.params.showGlobalLoading = true;
        $ctrl.tableObj.data = [];

        $fb.db.list('cad_areaMembros', [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}, {limit:[500]}]).then(list=>{

            $ctrl.tableObj.data = list.map((item)=>{
                return {
                    id: item.id,
                    capaUrl: item.data.inicio && item.data.inicio.capaMobUrl ? item.data.inicio.capaMobUrl : 'assets/images/empty-banner.webp',
                    nome: item.data.nome || null,
                    indice: `${item.data.nome || ''}`,
                    docPath: item.path
                }
            });

            $state.params.showGlobalLoading = false;
            _tableRerender();
        });        
    };

    const _editRegistro=(item)=>{
        $state.go('admin.editarAreaMembros', {idAreaMembros: item.id });
    };

    $ctrl.setTableFilter=(value, field)=>{
        if(field==="search"){
            if(!value.length){
                delete $ctrl.filter.indice;
            }else{
                $ctrl.filter.indice = value;
            }
        }else{
            if(!!value){
                $ctrl.filter[field] = value;
            }else{
                delete $ctrl.filter[field];
            }
        }
    };

    $ctrl.tableObj = {
        pageSize: 100,
        pageCount: 1,
        columns:[
            {title: '', key:'capaUrl', type:'image', export:false},
            {title: $text.name.toUpperCase(), width:'25%', key:'nome', type:'text', export:true}
        ],
        data:[],
        actions:{
            enable: {edit:true, view:true, delete:false},
            edit: _editRegistro,
            view: _editRegistro
        },
        bulkActions:{ enable: false }
    };

    
    $ctrl.$onInit = () => {
        
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;

        _getAreas();

    };
    
}]);